import React, { useEffect } from 'react';

import L from 'leaflet';
import { MapContainer, Polygon, TileLayer, useMap } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

interface Props {
    geoJson: string;
}

const parseRings = (geoJson: string): L.LatLngExpression[][][] => {
    if (!geoJson) return [];
    let parsed: any;
    try {
        parsed = JSON.parse(geoJson);
    } catch {
        return [];
    }
    const features = parsed?.type === 'FeatureCollection' ? parsed.features || [] : [parsed];
    const result: L.LatLngExpression[][][] = [];

    const toLatLng = (coords: number[][]): L.LatLngExpression[] =>
        coords.map((c) => [c[1], c[0]] as L.LatLngExpression);

    features.forEach((f: any) => {
        const geom = f?.geometry;
        if (!geom) return;
        if (geom.type === 'Polygon') {
            result.push(geom.coordinates.map(toLatLng));
        } else if (geom.type === 'MultiPolygon') {
            geom.coordinates.forEach((poly: number[][][]) => {
                result.push(poly.map(toLatLng));
            });
        }
    });

    return result;
};

const FitField: React.FC<{ rings: L.LatLngExpression[][][] }> = ({ rings }) => {
    const map = useMap();
    useEffect(() => {
        const points: L.LatLngExpression[] = [];
        rings.forEach((r) => r.forEach((ring) => points.push(...ring)));
        if (points.length > 0) {
            map.fitBounds(L.latLngBounds(points as L.LatLngTuple[]), { padding: [20, 20], maxZoom: 15 });
        }
    }, [rings, map]);
    return null;
};

const FieldMiniMap: React.FC<Props> = ({ geoJson }) => {
    const rings = parseRings(geoJson);

    if (rings.length === 0) {
        return null;
    }

    return (
        <div style={{ height: 240, borderRadius: 12, overflow: 'hidden', border: '1px solid #eef0f2' }}>
            <MapContainer center={[56.47, 84.54]} zoom={12} style={{ height: '100%', width: '100%' }} attributionControl={false}>
                <TileLayer
                    
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <FitField rings={rings} />
                {rings.map((ring, idx) => (
                    <Polygon
                        key={idx}
                        positions={ring}
                        pathOptions={{ color: '#417505', weight: 2, fillOpacity: 0.2 }}
                    />
                ))}
            </MapContainer>
        </div>
    );
};

export default FieldMiniMap;
